import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {

  majorLocations = [
    {name: 'Bhaktapur', route: '/location/bhaktapur', imagePath: 'assets/major-locations/bhaktapur.jpg'},
    {name: 'Biratnagar', route: '/location/biratnagar', imagePath: 'assets/major-locations/biratnagar.jpg'},
    {name: 'Birgunj', route: '/location/birgunj', imagePath: 'assets/major-locations/birgunj.jpg'},
    {name: 'Birtamod', route: '/location/birtamod', imagePath: 'assets/major-locations/birtamod.jpeg'},
    {name: 'Butwal', route: '/location/butwal', imagePath: 'assets/major-locations/butwal.jpg'},
    {name: 'Chitwan', route: '/location/chitwan', imagePath: 'assets/major-locations/chitwan.jpg'},
    {name: 'Damak', route: '/location/damak', imagePath: 'assets/major-locations/damak.jpeg'},
    {name: 'Dhangadi', route: '/location/dhangadi', imagePath: 'assets/major-locations/dhangadi.jpeg'},
    {name: 'Dharan', route: '/location/dharan', imagePath: 'assets/major-locations/dharan.jpg'},
    {name: 'Hetauda', route: '/location/hetauda', imagePath: 'assets/major-locations/hetauda.jpeg'},
    {name: 'Ilam', route: '/location/ilam', imagePath: 'assets/major-locations/ilam.jpg'},
    {name: 'Janakpur', route: '/location/janakpur', imagePath: 'assets/major-locations/janakpur.jpg'},
    {name: 'Kakarbhitta', route: '/location/kakarbhitta', imagePath: 'assets/major-locations/kakarbhitta.jpg'},
    {name: 'Kathmandu', route: '/location/kathmandu', imagePath: 'assets/major-locations/kathmandu.jpeg'},
    {name: 'Patan/Lalitpur', route: '/location/lalitpur', imagePath: 'assets/major-locations/lalitpur.jpg'},
    {name: 'Pokhara', route: '/location/pokhara', imagePath: 'assets/major-locations/pokhara.jpg'}
  ]

  provinceList = []

  districtList = []

  municipalityList = []

  validMunicipalityList = []

  validDistrictList = []

  province_id = new FormControl(null)

  district_id = new FormControl(null)

  municipality_id = new FormControl(null, [Validators.required])

  constructor(private route: ActivatedRoute, private router: Router, private readonly seoSocialShareService: SeoSocialShareService) { }

  seoData: SeoSocialShareData = {
    title:  'Neprose - Location',
    description: 'Find beautiful properties near you with NEPROSE.',
    image: environment.url+'/assets/logo.png'
  };

  ngOnInit(): void {
    this.seoSocialShareService.setData(this.seoData)
    this.route.data.subscribe((data: { provinceList: any, districtList: any, municipalityList: any }) =>{
      this.provinceList = data.provinceList.provinces
      this.districtList = data.districtList.districts
      this.municipalityList = data.municipalityList.municipalities
    })
    this.validDistrictList = this.districtList
    this.validMunicipalityList = this.municipalityList
  }

  onProvinceSelected($event){
    this.validDistrictList = []
    for(let district of this.districtList){
      if(district.province_id == $event){
        this.validDistrictList.push(district)
      }
    }
  }

  onDistrictSelected($event){
    this.validMunicipalityList = []
    for(let muncipality of this.municipalityList){
      if(muncipality.district_id == $event){
        this.validMunicipalityList.push(muncipality)
      }
    }
    let selectedDistrict = this.districtList.find(district => district.id == $event)
    if(selectedDistrict){
      this.province_id.setValue(selectedDistrict.province_id)
    }
  }

  onMunicipalitySelected($event){
    let selectedMunicipality = this.municipalityList.find(municipality => municipality.id == $event)
    if(selectedMunicipality){
      this.district_id.setValue(selectedMunicipality.district_id)
      let selectedDistrict = this.districtList.find(district => district.id == selectedMunicipality.district_id)
      if(selectedDistrict){
        this.province_id.setValue(selectedDistrict.province_id)
      }
    }
  }

  searchLocation(){
    if(this.municipality_id.valid){
      let municipality = this.municipalityList.find(municipality => municipality.id == this.municipality_id.value)
      this.router.navigate(['/location/'+municipality.municipality])
    }
  }

}
